import { OrderDto, OrderSchema } from "./order.model";
import { OrderDueDiligenceDto, OrderDueDiligenceSchema } from "./order-due-diligence.model";
import { PickupPointDto, PickupPointSchema } from "./pickup-point.model";
import { required } from "@corporate-tailwind/corp-form";
import { Validators } from "@angular/forms";
import { StripeDataDto } from "./order-stripe-data.model";
import { OrderIdentificationDto, OrderIdentificationSchema } from "./order-identification.model";
import { OrderGtcDto, OrderGtcSchema } from "./order-gtc.model";

export class OrderWizardDto {
    sessionId: string | null = null;
    activeStep: number = 0;
    languageCode: string | null = null;
    emailValidationTimeout: number | null = null;
    
    step01: OrderDto | null = null;
    step02: PickupPointDto | null = null;
    step03: OrderIdentificationDto | null = null;
    step04: OrderDueDiligenceDto | null = null;
    step05: OrderGtcDto | null = null;
    step06: StripeDataDto | null = null
}

export class OrderWizardSchema extends OrderWizardDto {
    static schema = {
        sessionId: { type: String },
        activeStep: { type: Number },
        languageCode: { type: String },
        emailValidationTimeout: { type: Number },
        step01: { type: OrderSchema, builderOption: required },
        step02: { type: PickupPointSchema },
        step03: { type: OrderIdentificationSchema, builderOption: required },  
        step04: { type: OrderDueDiligenceSchema, builderOption: required },
        step05: { type: OrderGtcSchema, builderOption: required }
    };
}
